import { Heart } from 'lucide-react';

import { LucideIcon } from '@/src/components/LucideIcon';
import { css } from '@/styled-system/css';

type FavoriteHeartIconProps = {
  selected: boolean;
};

const selectedHeart = css({
  '--favorite-heart-fill': '{colors.icon.favorite.fill}',
  '--favorite-heart-stroke': '{colors.icon.favorite.stroke}',
});

export function FavoriteHeartIcon({ selected }: FavoriteHeartIconProps) {
  return (
    <LucideIcon
      icon={Heart}
      className={selected ? selectedHeart : undefined}
      fill={selected ? 'var(--favorite-heart-fill)' : 'none'}
      color={selected ? 'var(--favorite-heart-stroke)' : 'currentColor'}
    />
  );
}
